import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { LINK_MANAGEMENT_TABS } from '../constants';
import { ELinkManagementTabs } from '../enums';
import React, { useState } from 'react';

interface ILinkManagementTableTabs {
  handleTableTabsChanges: (tab: ELinkManagementTabs) => void;
}

const LinkManagementTableTabs = ({ handleTableTabsChanges }: ILinkManagementTableTabs) => {
  const [selectedTab, setSelectedTab] = useState(ELinkManagementTabs.All);
  const handleTabsChange = (event: React.SyntheticEvent, newTab: ELinkManagementTabs) => {
    setSelectedTab(newTab);
    handleTableTabsChanges(newTab);
  };

  return (
    <ToggleButtonGroup
      value={selectedTab}
      onChange={handleTabsChange}
      color="primary"
      sx={{ marginBottom: '16px' }}
      exclusive
      fullWidth
    >
      {Object.entries(ELinkManagementTabs).map(([, tab]) => (
        <ToggleButton
          disabled={LINK_MANAGEMENT_TABS[tab as ELinkManagementTabs]?.disabled}
          key={tab}
          value={tab}
        >
          {LINK_MANAGEMENT_TABS[tab as ELinkManagementTabs]?.title}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default React.memo(LinkManagementTableTabs);
